import axios from 'axios';

const remove = async (groupId: string) => {
  const { data } = await axios.post(`/group/delete/${groupId}`);
  return data;
};

export default remove;
